import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QNE_TEMPLATE } from '@core';

@Component({
  selector: 'app-auto-recon-qne-tpl-select',
  templateUrl: './auto-recon-qne-tpl-select.component.html',
  styles: [],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QneTplSelectComponent),
      multi: true
    }
  ]
})
export class QneTplSelectComponent implements ControlValueAccessor {
  statusLabel: { [key: number]: string } = {};
  options = [...QNE_TEMPLATE];

  @Input() value: number = 0;

  get displayText() {
    const item = this.options.find(x => x.value === this.value);
    if (item) return item.label;
    return '';
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: number): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }
}
